import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from '@fluentui/react';
import { useAppShell } from '../AppShellContext';
import { useThemeData } from '@msrceng/theme';
/** Expand/collapse controls for the App Sidebar. */
export const AppSidebarExpander = () => {
    const { isAppSidebarExpanded, toggleAppSidebar } = useAppShell();
    const { theme: { palette, semanticColors }, } = useThemeData();
    return (_jsx(IconButton, { ariaLabel: isAppSidebarExpanded ? 'Expand.' : 'Minimize.', iconProps: {
            styles: {
                root: {
                    color: palette.neutralSecondary,
                    paddingRight: 16,
                },
            },
            iconName: isAppSidebarExpanded
                ? 'DoubleChevronLeft'
                : 'DoubleChevronRight',
        }, onClick: () => toggleAppSidebar(), styles: {
            flexContainer: {
                justifyContent: 'flex-end',
            },
            root: {
                borderTop: `1px solid ${semanticColors.bodyFrameDivider}`,
                color: palette.neutralSecondary,
                width: '100%',
                selectors: {
                    '.ms-Button-icon': {
                        paddingRight: 0,
                    },
                },
            },
        }, title: isAppSidebarExpanded ? 'Minimize Folder Pane' : 'Expand Folder Pane' }));
};
